import policyCodeToStatus from './policyCodeToStatus';
import policyStatusToColor from '../statusToColor';

export default (code) => {
  return policyStatusToColor(policyCodeToStatus(code));
};
